/**
 * Generated by orval v6.16.0 🍺
 * Do not edit manually.
 * inojin-stg-api
 * OpenAPI spec version: 1.0.0
 */

export type ClinicAccountModelDTORole = typeof ClinicAccountModelDTORole[keyof typeof ClinicAccountModelDTORole];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const ClinicAccountModelDTORole = {
  owner: 'owner',
  doctor: 'doctor',
  staff: 'staff',
} as const;
